import script from "./sliderNumberInputTuple.vue?vue&type=script&setup=true&lang=ts"
export * from "./sliderNumberInputTuple.vue?vue&type=script&setup=true&lang=ts"

import "./sliderNumberInputTuple.vue?vue&type=style&index=0&id=2fef28d9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2fef28d9"]])

export default __exports__